import React, { memo, useEffect, useState } from 'react';
import cn from 'clsx';

import styles from './image.scss';

interface ImageProps {
  alt: string;
  className?: string;
  disableDraggable?: boolean;
  height?: string;
  loading?: 'lazy' | 'eager';
  shouldFadeIn?: boolean;
  src: string;
  style?: object;
  title?: string;
  width?: string;
}

function Image(props: ImageProps) {
  const {
    alt,
    className,
    disableDraggable = false,
    height,
    loading,
    shouldFadeIn = true,
    src,
    style,
    title,
    width
  } = props;
  const [isReadyToLoad, setIsReadyToLoad] = useState(
    document.readyState === 'complete'
  );
  const [hasLoaded, setHasLoaded] = useState(false);
  let imgClassName = '';
  // Make sure images load after page load for perf
  const readySrc = isReadyToLoad
    ? src
    : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  if (shouldFadeIn) {
    imgClassName = hasLoaded
      ? `${styles['img']} ${styles['img--loaded']}`
      : styles['img'];
  }

  useEffect(() => {
    function handleDOMLoad() {
      setIsReadyToLoad(true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleDOMLoad);
    } else {
      handleDOMLoad();
    }

    return () => {
      document.removeEventListener('DOMContentLoaded', handleDOMLoad);
    };
  }, []);

  return (
    <img
      alt={alt}
      aria-label={alt}
      className={cn(imgClassName, className)}
      draggable={disableDraggable ? 'false' : true}
      height={height}
      loading={loading}
      onLoad={() => setHasLoaded(true)}
      src={readySrc}
      style={style}
      title={title}
      width={width}
    />
  );
}

export default memo(Image);
